import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { getDraftShareIdFromQueryParam } from '@confluence/route-manager-utils/entry-points/getDraftShareIdFromQueryParam.ts';

import EditorContentUnifiedQuery from './__generated__/EditorContentUnifiedQuery.graphql.ts';
import type {
	EditorContentUnifiedQuery$data,
	EditorContentUnifiedQuery$variables,
} from './__generated__/EditorContentUnifiedQuery.graphql.ts';
import { createEditorContentUnifiedQueryVariables } from './createEditorContentUnifiedQueryVariables.ts';
import { withEditorContentFreshness } from './editorContentFreshness.ts';

/**
 * Route and hover preload of EditorContentUnifiedQuery; EditorContentContainer reads it with the
 * same variables.
 */
export const preloadEditorContentUnifiedQuery = (
	contentId: string,
): ReturnType<
	typeof query<EditorContentUnifiedQuery$data, EditorContentUnifiedQuery$variables>
> => {
	const variables = createEditorContentUnifiedQueryVariables({
		contentId,
		draftShareId: getDraftShareIdFromQueryParam(),
	});

	return withEditorContentFreshness(variables, (fetchPolicy) =>
		query<EditorContentUnifiedQuery$data, EditorContentUnifiedQuery$variables>({
			query: EditorContentUnifiedQuery,
			variables,
			fetchPolicy,
		}),
	);
};
